import { Box, getVariant } from '@apia/theme';
import { PanelContainer } from '../../../types';
import { usePanelIdentity } from '../../../common';
import { NetworkState } from './NetworkState';
import { PanelButtons } from './PanelButtons';
import { usePanelIsLoading } from '../../../actions';
import { PanelContextProvider, useMakePanelContext } from '../PanelContext';
import { PanelFooter } from '../PanelContext/PanelFooter';
import {
  usePanelImage,
  usePanelTitleDescription,
} from '../../../panelsUtil/usePanelTitleAction';
import { AutoEllipsis } from '@apia/components';

export const DefaultPanelWrapper: PanelContainer = ({ children, ...props }) => {
  const { panelId, panelName, panelType } = usePanelIdentity();

  const { contextValue, title, ref, ...footerProps } =
    useMakePanelContext(props);

  const panelTitleDescription = usePanelTitleDescription();
  const panelImage = usePanelImage() ?? props.image;

  const showHeader =
    props.showTitle ||
    props.isConfigurable ||
    props.isRefreshable ||
    panelImage;

  const isLoading = usePanelIsLoading();
  return (
    <Box {...getVariant('layout.common.dashboards.panel')}>
      <PanelContextProvider value={contextValue}>
        <div
          ref={ref}
          className={`panel__container ${isLoading ? 'isLoading' : ''}`}
          data-panelname={panelName}
          data-paneltype={panelType}
          data-panelid={panelId}
        >
          {showHeader && (
            <div
              draggable={props.canMove}
              className={`panel__header ${props.canMove ? 'drag_panel_container' : ''}`}
            >
              <div
                className="panel__header__left"
                sx={{
                  maxWidth: '80%',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}
              >
                {panelImage && !panelImage.match('(^.+null$)') && (
                  <img src={panelImage} className="panel__icon" />
                )}
                <AutoEllipsis>
                  {props.showTitle && (
                    <span
                      className="panel__title"
                      title={panelTitleDescription ?? title}
                    >
                      {title}
                    </span>
                  )}
                  <NetworkState title={title} />
                </AutoEllipsis>
              </div>

              <div className={`panel__header__buttons`}>
                <PanelButtons {...props} id={panelId} />
              </div>
            </div>
          )}
          <div className="panel__content">{children}</div>
          <PanelFooter isRefreshable={props.isRefreshable} {...footerProps} />
        </div>
      </PanelContextProvider>
    </Box>
  );
};
